import { z } from 'zod';
import { API_DATE_FORMAT } from '~/constants/_constants';
import { zDbId, zLuxonDateTime } from '~/plugins/zod/utils';
import { OrderLinkSchema, PartnerSimpleSchema } from '~/api/links/_types';
import { PriceSchema } from '~/api/links/_types';
import { ContactSimpleSchema } from '../contacts/_types';

export const InvoiceSimpleSchema = z.object({
    Id: zDbId(),
    DocumentNumber: z.number(),
    ReferenceNumber: z.string().nullable(),
    DueAt: zLuxonDateTime({ format: API_DATE_FORMAT }),
    PostAt: zLuxonDateTime({ format: API_DATE_FORMAT }),
    File: z.string().nullable(),
});

export const InvoiceInfoSchema = InvoiceSimpleSchema.and(
    z.object({
        Partner: PartnerSimpleSchema.nullable(),
        Contact: ContactSimpleSchema.nullable(),
        Price: PriceSchema,
        Orders: OrderLinkSchema.array(),
    })
);

export const FetchInvoicesResponseSchema = InvoiceInfoSchema.array();

export type InvoiceInfo = z.infer<typeof InvoiceInfoSchema>;
export type FetchInvoicesResponse = z.infer<typeof FetchInvoicesResponseSchema>;
